import _ from 'lodash';

export function multiIncludes(value, containWords) {
    const regexp = new RegExp(containWords.join('|'));
    return regexp.test(value);
}

export const verifyStatusValid = (...verifyObjects) => {
    const validArr = _.map(verifyObjects, 'status');
    const valid = !_.includes(validArr, false);
    return valid
}


// WEBPACK FOOTER //
// ./src/utils/common-utils.js